import  { UserModule } from '@/store'

const usIntranetLogin = async () => {
  UserModule.is_loading && UserModule.closeLoading();
  await UserModule.CheckLogin();
}
export {
  usIntranetLogin
}
